export default "__VITE_ASSET__DLHpzZRb__"